import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import AllTrips from "./All-Trips.js";
import PastTrips from "./Past-Trip.js";
import UpcomingTrips from "./Upcoming-Trips.js";
import "./Trips.css";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

function Trips() {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="Trips-container">
            <Typography
                variant="h5"
                component="h1"
                gutterBottom
                className="main-title"
            >
                Trips
            </Typography>

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="trip tabs"
                    TabIndicatorProps={{ style: { display: "none" } }}
                    sx={{
                        "& .MuiTab-root": {
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: "14px",
                            fontFamily: "Poppins, sans-serif",
                            color: "#000",
                            borderBottom: "2px solid transparent",
                            outline: "none",
                        },
                        "& .Mui-selected": {
                            color: "rgba(89, 50, 234, 1)",
                            borderBottom: "2px solid rgba(89, 50, 234, 1)",
                        },
                        "& .MuiTab-root:focus": {
                            outline: "none",
                        },
                    }}
                >
                    <Tab label="All Trips" {...a11yProps(0)} />
                    <Tab label="Past" {...a11yProps(1)} />
                    <Tab label="Upcoming" {...a11yProps(2)} />
                </Tabs>
            </Box>

            <CustomTabPanel value={value} index={0}>
                <AllTrips />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <PastTrips />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                <UpcomingTrips />
            </CustomTabPanel>
        </div>
    );
};

export default Trips;